export function resetJS(ignoreClass) {
    document
        .querySelectorAll(`script:not(${ignoreClass})`)
        .forEach((script) => script.remove());
}
